import React, { useState } from "react";
import customer_avatar from "../../assets/images/customer_avatar.png";
import PdfPreviewModal from "./CG_PDFModal";

export default function CG_Header({ screen }) {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState(".pdf");
    const handlePreview = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    return (
        <div className="tw-bg-[#F0F0F0] tw-flex tw-w-full tw-justify-between tw-items-center tw-px-5 tw-py-2">
            <PdfPreviewModal isOpen={modalIsOpen} onClose={closeModal} imageUrl={previewImageUrl} />
            <h1 className="tw-hidden xl:tw-block">AireBrokers LOGO</h1>
            <div className="tw-flex tw-items-center tw-w-full xl:tw-w-auto tw-justify-between xl:tw-justify-end tw-gap-2">
                {screen ? (
                    ""
                ) : (
                    <>
                        <p>Step</p>
                        <select className="tw-rounded-md tw-py-2 tw-px-3">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                        </select>
                        <p>of 10</p>{" "}
                    </>
                )}
                <img
                    src={customer_avatar}
                    className="tw-h-[30px] xl:tw-h-[40px] tw-w-[30px] xl:tw-w-[40px] tw-object-contain"
                    alt="customer-support"
                />
                {screen ? (
                    ""
                ) : (
                    <>
                        <button
                            onClick={handlePreview}
                            className="tw-bg-[#001659] tw-text-[14px] xl:tw-text-[18px] tw-rounded-md tw-font-[700] tw-px-3 tw-py-1 tw-text-white"
                        >
                            Preview your Contract
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
